<lib-user-profile
    title="Profile"
    [headerType]="viewingAs() === 'self' ? 'user-profile' : 'default'"
    (onSettingsButtonClick)="goTo('/settings')"
    [avatarImage]="user()?.avatar_url"
    [cards]="
        viewingAs() === 'self'
            ? [
                  {
                      type: 'rating',
                      value: user()?.star_rating
                  },
                  {
                      type: 'confirmed_jobs',
                      value: user()?.confirmed_jobs_total,
                      size: '5'
                  },
                  {
                      type: 'call_offs_rate',
                      value: user()?.call_offs_rate
                  }
              ]
            : [
                  {
                      type: 'attendance_rate',
                      value: 1 - (user()?.call_offs_rate || 0)
                  },
                  {
                      type: 'rating',
                      value: user()?.star_rating
                  },
                  {
                      type: 'confirmed_jobs',
                      value: user()?.confirmed_jobs_total
                  }
              ]
    ">
    <div ngProjectAs="top-content">
        <h1 class="h2 ion-text-center ion-no-margin ion-margin-top">
            @if (user()?.first_name) {
                {{ user()?.first_name | shortenName: user()?.last_name }}
            } @else if (user()?.name) {
                {{ user()?.name }}
            }
        </h1>
    </div>

    <div class="ion-margin-vertical">
        <ion-segment [value]="segmentSelected()" (ionChange)="segmentChange($event)">
            <ion-segment-button value="about" content-id="about">About</ion-segment-button>
            <ion-segment-button
                value="availability"
                content-id="availability"
                [disabled]="viewingAs() === 'self' && (proUserService.isApplicant() || proUserService.isLead())">
                Availability
            </ion-segment-button>
            <ion-segment-button
                value="reviews"
                content-id="reviews"
                [disabled]="viewingAs() === 'self' && (proUserService.isApplicant() || proUserService.isLead())">
                Reviews
            </ion-segment-button>
        </ion-segment>

        <ion-segment-view>
            <ion-segment-content id="about">
                <div>
                    <h2 class="h4">About</h2>
                    <p>
                        @if (user()?.bio) {
                            {{ user()?.bio }}
                        } @else {
                            No information added.
                        }
                    </p>
                </div>
            </ion-segment-content>
            <ion-segment-content id="availability">
                @if (user()) {
                    <h2 class="h4">Availability</h2>
                    <p *ngIf="viewingAs() === 'self'">
                        Set specific working days and times that you are interested in.
                    </p>

                    @if (weekdayMorning() || weekdayEvening() || weekdayOvernight()) {
                        <h2 class="h4">Weekdays</h2>
                    }

                    @if (weekdayMorning()) {
                        <ng-content *ngTemplateOutlet="timeDisplay; context: { label: 'Morning' }" />
                    }

                    @if (weekdayEvening()) {
                        <ng-content *ngTemplateOutlet="timeDisplay; context: { label: 'Evening' }" />
                    }

                    @if (weekdayOvernight()) {
                        <ng-content *ngTemplateOutlet="timeDisplay; context: { label: 'Overnight' }" />
                    }

                    @if (weekendMorning() || weekendEvening() || weekdayOvernight()) {
                        <h2 class="h4">Weekends</h2>
                    }

                    @if (weekendMorning()) {
                        <ng-content *ngTemplateOutlet="timeDisplay; context: { label: 'Morning' }" />
                    }

                    @if (weekendEvening()) {
                        <ng-content *ngTemplateOutlet="timeDisplay; context: { label: 'Evening' }" />
                    }

                    @if (weekdayOvernight()) {
                        <ng-content *ngTemplateOutlet="timeDisplay; context: { label: 'Overnight' }" />
                    }
                }
            </ion-segment-content>
            <ion-segment-content id="reviews">
                @if (user()) {
                    <lib-review-item
                        [starRating]="user()?.star_rating || 0"
                        [totalReviews]="user()?.reviews?.length || 0"
                        [reviews]="user()?.reviews || []"></lib-review-item>
                }
            </ion-segment-content>
        </ion-segment-view>
    </div>
</lib-user-profile>

<ng-template #timeDisplay let-label="label">
    <div class="chip-item chip-highlight">
        <p>{{ label }}</p>
    </div>
</ng-template>
